exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page-head {\n  color: #929292;\n  position: relative;\n  min-height: 140px;\n  background-color: #b9d9f9;\n}\n.page-head .page-head-content {\n  padding-top: 52px;\n  padding-bottom: 52px;\n}\n.page-head .page-head-content .page-title {\n  margin: 0px;\n  padding: 10px 16px;\n  font-size: 40px;\n  color: #929292;\n  font-weight: 500;\n}\n", ""]);

// exports
